import React, {useEffect} from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/header/header';
import Footer from './components/footer/footer';
import Home from './pages/landpage/landpage';
import Connect from './pages/connect/connect';
import Departments from './pages/landpages-extra/departments';
import Events from './pages/landpages-extra/events';
import Give from './pages/give/give';
import Leadership from './pages/landpages-extra/leadership';
import New from './pages/landpages-extra/new';
import VisionMission from './pages/landpages-extra/mission';
import Visit from './pages/landpages-extra/visit';
import './App.css';

function ScrollToTopOnRouteChange() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <BrowserRouter>
    <ScrollToTopOnRouteChange />
      <div className="App">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/give" element={<Give />} />
            <Route path="/connect" element={<Connect />} />
            <Route path="/departments" element={<Departments />} />
            <Route path="/leadership" element={<Leadership />} />
            <Route path="/new" element={<New />} />
            <Route path="/visit" element={<Visit />} /> 
            <Route path="/upcoming-events" element={<Events />} />
            <Route path="/vision-mission" element={<VisionMission />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
